
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { NextPage } from 'next';
import ErrorFeature from 'features/error';

const Custom404: NextPage<Record<string, never>> = () => <ErrorFeature statusCode={404} />;

export default Custom404;
